export default "__VITE_ASSET__e36eb34a__"